export default "__VITE_ASSET__DARyUqv1__"